module.exports = __webpack_public_path__ + "static/media/VisionReimbursementForm.f94043e2.pdf";